import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Timeline = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)" fillRule="evenodd" clipRule="evenodd" fill={color}>
      <Path d="M11.82 7.46a.8.8 0 0 1 .8.8v3.2h1.99a.8.8 0 0 1 0 1.6h-2.79a.8.8 0 0 1-.8-.8v-4a.8.8 0 0 1 .8-.8Z" />
      <Path d="M7.84 6.454a6.94 6.94 0 0 1 11.1 5.556A6.933 6.933 0 0 1 12 18.95a6.933 6.933 0 0 1-6.94-6.94.8.8 0 0 0-1.6 0A8.533 8.533 0 0 0 12 20.55a8.533 8.533 0 0 0 8.54-8.54A8.54 8.54 0 0 0 6.924 5.141l.025-.457a.8.8 0 0 0-1.598-.088l-.15 2.72a.8.8 0 0 0 .844.843l2.64-.15a.8.8 0 1 0-.09-1.598l-.756.043Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Timeline
